/** 26 dark, high-contrast colors keyed by A-Z (index 0 = 'A') - deterministic
 * so the same contact always gets the same color, same idea as WhatsApp's
 * initials-avatar fallback when there's no profile picture. */
const PALETTE = [
  '#5B4636',
  '#8B4513',
  '#B22222',
  '#8B008B',
  '#4B0082',
  '#2F4F4F',
  '#1E3A5F',
  '#006064',
  '#004D40',
  '#1B5E20',
  '#33691E',
  '#827717',
  '#E65100',
  '#BF360C',
  '#3E2723',
  '#263238',
  '#37474F',
  '#4A148C',
  '#880E4F',
  '#B71C1C',
  '#1A237E',
  '#0D47A1',
  '#01579B',
  '#00695C',
  '#6A1B9A',
  '#512DA8',
];

export function getInitials(displayName: string): string {
  const parts = displayName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0] ?? '';
  if (parts.length === 1) return first.slice(0, 2).toUpperCase();
  const last = parts[parts.length - 1] ?? '';
  return (first.charAt(0) + last.charAt(0)).toUpperCase();
}

export function colorForName(displayName: string): string {
  const letter = displayName.trim().charAt(0).toUpperCase();
  const index = letter >= 'A' && letter <= 'Z' ? letter.charCodeAt(0) - 65 : 0;
  return PALETTE[index] ?? PALETTE[0]!;
}

/** WhatsApp-style initials avatar used wherever there's no profile picture. */
export function Avatar({ name, size = 40 }: { name: string; size?: number }) {
  return (
    <div
      className="ne-avatar"
      style={{
        width: size,
        height: size,
        fontSize: size * 0.4,
        background: colorForName(name),
      }}
      aria-hidden="true"
    >
      {getInitials(name)}
    </div>
  );
}
